module.exports = __webpack_public_path__ + "img/img-default-colaborador.a954c435.jpg";